import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ConditionSerializer21tf3x2n3amih as ConditionSerializer } from './ConditionSerialization.mjs';
import { ModificationSerializer3ubms8rrlijys as ModificationSerializer } from './ModificationSerialization.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.MassModification', null, 2);
        tmp0_serialDesc.c1b('condition', false);
        tmp0_serialDesc.c1b('modification', false);
        this.p3l_1 = tmp0_serialDesc;
      }
      d2j(typeSerial0) {
        return $serializer().z40(typeSerial0);
      }
      h1c(typeParamsSerializers) {
        return this.d2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      static a41() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningdb.MassModification', $this, 2);
        tmp0_serialDesc.c1b('condition', false);
        tmp0_serialDesc.c1b('modification', false);
        $this.x40_1 = tmp0_serialDesc;
        return $this;
      }
      b41(encoder, value) {
        var tmp0_desc = this.x40_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        tmp1_output.c15(tmp0_desc, 0, new (ConditionSerializer())(this.y40_1), value.c41_1);
        tmp1_output.c15(tmp0_desc, 1, new (ModificationSerializer())(this.y40_1), value.d41_1);
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b41(encoder, value instanceof MassModification() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.x40_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.l13(tmp0_desc);
        if (tmp6_input.a14()) {
          tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.y40_1), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.y40_1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.x13(tmp0_desc, 0, new (ConditionSerializer())(this.y40_1), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.x13(tmp0_desc, 1, new (ModificationSerializer())(this.y40_1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp6_input.m13(tmp0_desc);
        return MassModification().e41(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      az() {
        return this.x40_1;
      }
      t1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [new (ConditionSerializer())(this.y40_1), new (ModificationSerializer())(this.y40_1)];
      }
      u1b() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.y40_1];
      }
      static z40(typeSerial0) {
        var $this = this.a41();
        $this.y40_1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var MassModificationClass;
function MassModification() {
  if (MassModificationClass === VOID) {
    class $ {
      constructor(condition, modification) {
        Companion_getInstance();
        this.c41_1 = condition;
        this.d41_1 = modification;
      }
      toString() {
        return 'MassModification(condition=' + toString(this.c41_1) + ', modification=' + toString(this.d41_1) + ')';
      }
      hashCode() {
        var result = this.c41_1.hashCode();
        result = imul(result, 31) + hashCode(this.d41_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MassModification()))
          return false;
        if (!this.c41_1.equals(other.c41_1))
          return false;
        if (!equals(this.d41_1, other.d41_1))
          return false;
        return true;
      }
      static e41(seen0, condition, modification, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance().p3l_1);
        }
        var $this = createThis(this);
        $this.c41_1 = condition;
        $this.d41_1 = modification;
        return $this;
      }
    }
    initMetadataForClass($, 'MassModification', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    MassModificationClass = $;
  }
  return MassModificationClass;
}
//region block: exports
export {
  MassModification as MassModification2g7vooufrvzd,
  Companion_getInstance as Companion_getInstance15uq20f985jxw,
};
//endregion

//# sourceMappingURL=MassModification.mjs.map
